var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147.9 142",
    style: {
      enableBackground: "new 0 0 147.9 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.6,37.5v34.7c0,2.3-0.9,4.5-2.5,6.1l-59.9,60.7c-3.4,3.5-9,3.5-12.4,0L3,103.6c-3.4-3.4-3.3-9,0.1-12.3 L64,31.4c1.6-1.6,3.8-2.5,6.1-2.5l22.8-0.1c-1.4,3.1-2.8,6-4.1,8.7c-8,0.4-14.3,7.1-14.3,15.2c0,8.4,6.8,15.2,15.2,15.2 c8.4,0,15.2-6.8,15.2-15.2c0-4-1.6-7.7-4.1-10.4c1.7-3.6,3.7-7.9,6.1-13.1C110.1,30.4,112.6,33.7,112.6,37.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.3,54v29.4c0,2-0.8,3.9-2.2,5.3l-49.3,49.5c-1.8,1.8-4.8,1.8-6.6,0l-3.6-3.7l53.1-52.2 c1.8-1.7,2.8-4.1,2.8-6.6V53.2L122,52C123.5,51.2,125.3,52.3,125.3,54z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.2,45.3C128.2,45.3,128.2,45.3,128.2,45.3c-2.8,1.4-5.9,2.7-9.4,3.9l-1.6-4.6c7.7-2.7,13.9-6,18.3-9.7 c5.3-4.6,8-9.9,7.6-15.4c-0.5-6.9-6.2-12.9-13.4-14.2c-9.3-1.7-18.3,4.5-24,16.6c-1.2,2.5-2.2,4.9-3.2,7c-2,4.3-3.6,7.9-5.1,10.9 c-1,2.1-1.9,3.9-2.6,5.5c1.2,1,2.2,2.3,2.7,3.9c0.3,0.8,0.5,1.7,0.5,2.7c0,4.6-3.7,8.3-8.3,8.3c-0.3,0-0.5,0-0.8,0 c-1.5-0.1-2.9-0.7-4.1-1.5c-2.1-1.5-3.5-4-3.5-6.8c0-3.1,1.7-5.8,4.1-7.2c1.2-0.7,2.7-1.1,4.2-1.1c0.2,0,0.4,0,0.5,0 c0.8-1.7,1.7-3.6,2.6-5.6c1.4-2.9,2.8-6,4.2-9.1c1.5-3.2,3-6.4,4.2-9.1c6.7-14.3,17.7-21.5,29.4-19.4C140,2.1,147.3,10,148,19 C148.3,24.2,146.9,36,128.2,45.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrands);
export default __webpack_public_path__ + "static/media/Brands.2afd468e059e18f49c094788f5ecc9bf.svg";
export { ForwardRef as ReactComponent };